// ============================================================
// RECURRING ENGINE CONSTANTS
// ============================================================

export const EngineResult = {

    READY: 'READY',

    INACTIVE: 'INACTIVE',

    PAUSED: 'PAUSED',

    ARCHIVED: 'ARCHIVED',

    ALREADY_GENERATED: 'ALREADY_GENERATED',

    NOT_SCHEDULED: 'NOT_SCHEDULED',

    NOT_READY: 'NOT_READY',

    NOT_IMPLEMENTED: 'NOT_IMPLEMENTED',

    UNKNOWN_TYPE: 'UNKNOWN_TYPE',

    NOT_STARTED: 'NOT_STARTED',

    EXPIRED: 'EXPIRED'
}